export default "/etc.clientlibs/des/cart-checkout/clientlibs/des-cart-checkout/resources/fad7cd2f61051969e1b83c4752afd076.png";